var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-headful',{attrs:{"title":_vm.$t('meta.title'),"description":_vm.$t('meta.description'),"html":{ body: {id: _vm.$route.meta.id } },"lang":_vm.$route.meta.lang,"head":{
      'link[rel^=shortcut]': {href: ((_vm.$root['/']) + "icons/favicon.png")},
      'link[rel=apple-touch-icon]': {href: ((_vm.$root['/']) + "icons/apple-touch-icon.png")},

      'meta[property^=og][property$=title]': {content: ("" + (_vm.$t('meta.title')))},
      'meta[property^=og][property$=image]': {content: ((_vm.$root.baseurl) + "icons/apple-touch-icon.png")},
      'meta[property^=og][property$=url]': {content: _vm.$root.baseurl},
      'meta[property^=og][property$=description]': {content: ("" + (_vm.$t('meta.description')))},

      'meta[name^=twitter][name$=title]': {content: ("" + (_vm.$t('meta.title')))},
      'meta[name^=twitter][name$=image]': {content: ((_vm.$root.baseurl) + "icons/apple-touch-icon.png")},
      'meta[name^=twitter][name$=description]': {content: ("" + (_vm.$t('meta.description')))},
    }}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }